import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/modules/auth'
import http from '@/store/modules/http'
import error from '@/store/modules/error'
import userinfo from '@/store/modules/userinfo'
import topicList from '@/store/modules/topicList'
import topic from '@/store/modules/topic'
import favorite from '@/store/modules/favorite'
import searchTopicList from '@/store/modules/searchTopicList'
import signup from '@/store/modules/signup'
import passwordReset from '@/store/modules/passwordReset'
import inquiryModal from '@/store/modules/inquiryModal'
import bookmark from '@/store/modules/bookmark'
import contributorRanking from '@/store/modules/contributorRanking'
import tagRanking from '@/store/modules/tagRanking'
import notice from'@/store/modules/notice'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    http,
    error,
    userinfo,
    topicList,
    topic,
    favorite,
    searchTopicList,
    signup,
    passwordReset,
    inquiryModal,
    bookmark,
    contributorRanking,
    tagRanking,
    notice
  },
  plugins: [createPersistedState({
    key: 'example',
    paths: [
      'auth'
    ],
    storage: window.localStorage
  })]
})